import { useState } from 'react';

// eslint-disable-next-line import/prefer-default-export
export const useForm = (initialState, onSubmit) => {
	const [formData, setFormData] = useState(initialState);

	const handleOnSubmit = (event) => {
		if (event) event.preventDefault();

		if (onSubmit && typeof onSubmit === 'function') {
			onSubmit();
		}
	};

	const handleOnChange = (event) => {
		event.persist();
		setFormData((dataForm) => ({
			...dataForm,
			[event.target.name]:
				event.target.type === 'checkbox'
					? event.target.checked
					: event.target.value,
		}));
	};

	return {
		formData,
		handleOnChange,
		handleOnSubmit,
	};
};

useForm.defaultProps = {
	initialState: {},
};
